import type { FeedbackMessages } from './en';

const id: FeedbackMessages = {
  qualified: {
    title: 'Terima kasih telah menyelesaikan studi ini!',
    body1: 'Anda dapat menutup jendela browser ini.',
    body2: 'Kami berharap dapat bertemu dengan Anda lagi segera.',
    refCode: 'Kode Referensi: {code}',
  },
  quotaFull: {
    title: 'Studi ini telah ditutup',
    body1: 'Terima kasih atas minat Anda terhadap studi kami.',
    body2: 'Sayangnya kami telah menerima semua tanggapan yang kami perlukan.',
    body3: 'Kami berharap dapat bertemu dengan Anda di salah satu studi kami mendatang!',
    refCode: 'Kode Referensi: {code}',
  },
  terminated: {
    title: 'Terima kasih telah membagikan masukan Anda!',
    body1:
      'Kami berharap dapat bertemu dengan Anda kembali di studi kami mendatang. Sampai saat itu, kami mengucapkan semoga hari Anda menyenangkan.',
    body2: 'Silakan tutup jendela browser ini.',
    refCode: 'Kode Referensi: {code}',
  },
  mismatch: {
    title: 'Terima kasih atas minat Anda',
    body1: 'Sayangnya, Anda tidak termasuk dalam kelompok target untuk studi khusus ini.',
    body2: 'Anda dapat menutup halaman ini.',
    code: 'Kode: {code}',
  },
  error: {
    title: 'Kami tidak dapat memproses permintaan Anda',
    linkProblemDetailed:
      'Tautan yang Anda ikuti mengalami masalah. Mohon periksa apakah tautan pada baris alamat sesuai dengan yang diberikan kepada Anda, kemudian coba lagi.',
    linkProblemGeneric:
      'Tautan yang Anda ikuti mengalami masalah. Mohon coba lagi.',
    contactPerson:
      'Jika masalah ini masih berlanjut, mohon beri tahu orang yang memberikan tautan ini kepada Anda mengenai masalah ini.',
    errorCode: 'Kode Kesalahan: {code}',
  },
};

export default id;
